function bindReadMoreMobileOnly() {
  if (window.innerWidth <= 575) {
    const $formatBlock = $('.supplemental-formates__block');
    if($formatBlock.length > 0) {
      $formatBlock.each(function () {
        const $block = $(this);
        const $readMore = $block.find('.read-more');
        const $desc = $block.find('.desc');
  
        // Prevent multiple bindings
        $readMore.off('click').on('click', function (e) {
          e.preventDefault();
          $desc.toggleClass('expanded');
          $readMore.text($desc.hasClass('expanded') ? 'Read Less' : 'Read More');
        });
      });
    }
  }
}

// Run once on page load
$(window).on('load', function () {
  bindReadMoreMobileOnly();

  // Slick slider init only if element exists
  const $logoSlider = $('.js-logo-with-text');
  if ($logoSlider.length && typeof $logoSlider.slick === 'function') {
    $logoSlider.slick({
      speed: 4000,
      autoplay: true,
      autoplaySpeed: 0,
      centerMode: true,
      cssEase: 'linear',
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      infinite: true,
      initialSlide: 1,
      arrows: false,
      buttons: false
    });
  }
});

// Rebind on resize
$(window).on('resize', function () {
  if (window.innerWidth <= 575) {
    bindReadMoreMobileOnly();
  } else {
    // Reset all on desktop
    $('.supplemental-formates__block .desc').removeClass('expanded');
    $('.supplemental-formates__block .read-more').text('Read More');
  }
});
